<template>
  <div>
    <b-btn variant="info" class="btn btn-sm mb-2" @click="generateOrderPdf" :disabled="order.items.length <= 0">Download PDF</b-btn>
    <vue-html2pdf
      :show-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="caterer-order"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="generatePdf"
      margin="10"
    >
      <section slot="pdf-content">
          <!-- PDF Content Here -->
          <section slot="pdf-content">
            <section class="pdf-item">
              <div class="container-fluid mt-4 d-flex justify-content-center">
                <div class="card card-1">
                    <div class="card-body">
                        <div class="row text-center mt-3 mb-5">
                            <div class="col">
                                <h4 class="mb-0">{{order.title}}</h4>
                                <h5 class="mt-0">{{order.categring.eventType</h5>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-7 text-left">
                                <div class="row mb-2">
                                  <div class="col-4">
                                    Event Date: 
                                  </div>
                                  <div class="col-8 order-description">
                                    {{ order.catering.eventDate }}
                                  </div>
                                </div>
                                <div class="row mb-2">
                                  <div class="col-4">
                                    # Guests: 
                                  </div>
                                  <div class="col-8 order-description">
                                    {{ order.catering.numberGuests }}
                                  </div>
                                </div>
                            </div>
                            <div class="col-5 text-right"> <small>Order Date : {{ order.orderDate }} </small> </div>
                        </div>
                        <div class="row">
                            <div class="col" v-html="generatedOrderItemsHtml">
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </section>
          </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'GenerateOrderPdf',
  props: [
    'order',
    'priceLevel'
  ],
  components: { VueHtml2pdf },
  computed: {
    generatedOrderItemsHtml () {
      let that = this;
      let html = '<table class="table">';
      let items = [];
      
      let filterItems = this.order.items.reduce(function (r, a) {
          r[a.category] = r[a.category] || [];
          r[a.category].push(a);
          return r;
      }, Object.create(null));

      Object.keys(filterItems).map((key, item) => {
        html += '<thead>';
        html += '<tr>';
        html += '<th scope="col" colspan="5" class="item-category">';
        html += '<div style="float: left">';
        html += key;
        html += '</div>';
        html += '<div style="float: right">';
        html += 'Servings: '+that.getTotalServingByCategory(filterItems[key]);
        html += ' , Amount: '+that.getTotalPriceByCategory(filterItems[key]);
        html += '</div></th>';
        html += '</tr>';
        html += '<tr>';
        html += '<th scope="col">Item Name</th>';
        html += '<th scope="col">Servings</th>';
        html += '<th scope="col">Quantity</th>';
        html += '<th scope="col">Unit Cost</th>';
        html += '<th scope="col">Total</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        filterItems[key].map(filterItem => {
          html += '<tr>';
          html += '<td>'+filterItem.title+'</td>';
          html += '<td>'+filterItem.qty * (filterItem.servings || 1) +'</td>';
          html += '<td>'+filterItem.qty+'</td>';
          html += '<td>'+filterItem.price[this.priceLevel]+'</td>';
          html += '<td>'+filterItem.price[this.priceLevel] * filterItem.qty+'</td>';
          html += '</tr>';
        })
        html += '</tbody>';
      })
      html += '</table>';
      return html;
    }
  },
  methods: {
    generateOrderPdf() {
      this.$refs.generatePdf.generatePdf();
    },
    getTotalServingByCategory(itemRow) {
      let totalServing = 0;
      itemRow.map((item) => {
        totalServing += item.qty * item.servings;
      })
      return totalServing;
    },
    getTotalPriceByCategory(itemRow) {
      let that = this;
      let totalPrice = 0;
      let subTotal = 0;
      let total = 0;
      let tax = 0;
      itemRow.map((item) => {
        subTotal += item.price[this.priceLevel] * item.qty;
      })
      totalPrice = parseFloat(subTotal + tax).toFixed(2);
      return totalPrice;
    },
  }
}
</script>

<style>
  .card-1 {
    min-width: 800px;
    width: 100%;
    margin: 0 auto;
  }
  .card-body {
    padding: 14px;
  }
  .item-category {
    background: #4C5465;
    color: #fff;
    text-align: left;
    text-transform: capitalize;
  }
  .order-description {
    border-bottom: 1px dotted #2c3e50;
    padding-left: 8px;
  }
</style>